
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","clip-path":"url(#clip0_160_3281)","fill":"#282828"}},[_c('path',{attrs:{"d":"M9 14c3.315 0 6-2.685 6-6V0h-2.5v8c0 1.935-1.565 3.5-3.5 3.5A3.497 3.497 0 015.5 8V0H3v8c0 3.315 2.685 6 6 6zM16 16H2v2h14v-2z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_160_3281"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    